






import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import { GrowthMindsetMap, GrowthMindsetMapData } from '@/models/school-group/school-group-trend-analysis';
import moment from 'moment';

@Component({
  name: 'GTrendAnalysisGrowthMindsetMapChart',
})
export default class GTrendAnalysisGrowthMindsetMapChart extends mixins(GPageBase) {
  @Prop() data: GrowthMindsetMap;
  chartOptions: any = {};
  chart: any;

  get allData(): GrowthMindsetMapData[] {
    return [...this.data.latestData, ...this.data.lastData];
  }

  get hasUnderMinus50XPosData(): boolean {
    return this.allData.filter((d: any) => d.xPos <= -1).length > 0;
  }

  get hasUnderMinus50YPosData(): boolean {
    return this.allData.filter((d: any) => d.yPos <= -1).length > 0;
  }

  get isShowUnderMinus50Data(): boolean {
    return this.hasUnderMinus50XPosData || this.hasUnderMinus50YPosData;
  }

  mounted() {
    // AIGROW2-664 クラスマネジメント・統計情報のグラフから生徒カルテへ遷移
    const refs = this.$refs as any;
    this.chart = refs.growthMindSetMapChart.chart;
    this.chart.on('click', (params: any) => {
      const url = this.$router.resolve({
        name: 'student-record',
        params: { studentID: params.data.studentID }
      }).href
      window.open(url, '_blank')
    });

    this.chartOptions = {
      toolbox: {
        show: true,
        top: '50',
        right: 0,
        itemSize: 15,
        feature: {
          dataZoom: { show: true, title: { zoom: this.$t('ENLARGE').toString(), back: this.$t('UNDO').toString() } },
          restore: { show: true, title: this.$t('RESET').toString() },
        },
      },
      title: [
        { left: 'center', top: 10, text: this.$t('GROWTH_MINDSET').toString() },
        {
          show: true,
          text: this.$t('GROWTH_MIND_SET_MAP_DESC_ZONE_3').toString(),
          textStyle: {
            color: 'pink',
          },
          top: '3%',
          left: '0%',
        },
        {
          show: true,
          text: this.$t('GROWTH_MIND_SET_MAP_DESC_ZONE_1').toString(),
          textStyle: {
            color: 'purple',
          },
          top: '3%',
          right: '0%',
        },
        {
          show: true,
          text: this.$t('GROWTH_MIND_SET_MAP_DESC_ZONE_4').toString(),
          textStyle: {
            color: 'orange',
          },
          bottom: '0%',
          left: '0%',
        },
        {
          show: true,
          text: this.$t('GROWTH_MIND_SET_MAP_DESC_ZONE_2').toString(),
          textStyle: {
            color: 'lime',
          },
          bottom: '0%',
          right: '0%',
        },
      ],
      legend: {
        data: [
          this.$t('LATEST').toString() + ' : (' + moment(this.data.latestTime).format('YYYY-MM-DD') + ')',
          this.$t('LAST_TIME').toString() + ' : (' + moment(this.data.lastTime).format('YYYY-MM-DD') + ')'
        ],
        top: 100,
        right: 0,
        orient: 'vertical',
      },
      grid: {
        show: false,
        width: "70%",
      },
      xAxis: {
        type: 'value',
        name: this.$t('SELF_EFFICACY').toString(),
        nameTextStyle: {
          fontSize: 14,
          fontWeight: 'bold',
        },
        nameLocation: 'center',
        axisLine: {
          onZero: false,
        },
        nameGap: 30,
        splitNumber: 9,
        max: 100,
        min: this.isShowUnderMinus50Data ? -100 : -50,
      },
      yAxis: {
        type: 'value',
        name: this.$t('SELF_ESTEEM').toString(),
        nameTextStyle: {
          fontSize: 14,
          fontWeight: 'bold',
        },
        nameLocation: 'center',
        axisLine: {
          onZero: false,
        },
        nameGap: 30,
        splitNumber: 9,
        max: 100,
        min: this.isShowUnderMinus50Data ? -100 : -50,
      },
      series: [
        {
          //name: '前回',
          name: this.$t('LAST_TIME').toString() + ' : (' + moment(this.data.lastTime).format('YYYY-MM-DD') + ')',
          symbolSize: 10,
          data: this.data.lastData.map(generateSeriesData),
          itemStyle: {
            color: 'gray',
          },
          type: 'scatter',
        },
        {
          //name: '最新',
          name: this.$t('LATEST').toString() + ' : (' + moment(this.data.latestTime).format('YYYY-MM-DD') + ')',
          symbolSize: 10,
          data: this.data.latestData.map(generateSeriesData),
          itemStyle: {
            color: 'red',
          },
          type: 'scatter',
        },
      ],
    };
  }
}

const generateSeriesData = (d: GrowthMindsetMapData) => {
  const { xPos, yPos } = d;
  const displayXPos = 50 * xPos;
  const displayYPos = 50 * yPos;
  return {
    name: d.fullName,
    studentID: d.student.studentID,
    value: [displayXPos, displayYPos],
    label: {
      show: true,
      formatter: '{b}',
      color: '#000000',
      fontSize: 10,
      position: 'top',
      distance: 3,
    },
  };
};
